import React, { useEffect } from 'react';
import { Amplify } from 'aws-amplify';
import amplifyconfig from './amplifyconfiguration';
import { ThemeProvider, CssBaseline, GlobalStyles } from '@mui/material';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './App.css';
import './rtl.css'; // RTL support for Arabic
import './i18n'; // Import i18n configuration
import { createAwqafTheme } from './theme';
import LayoutApp from './components/LayoutApp';
import Auth from './components/Auth';

// Configure Amplify
Amplify.configure(amplifyconfig);

function App() {
  // Force Arabic RTL direction
  const theme = createAwqafTheme('rtl');

  useEffect(() => {
    // Set document direction to RTL for Arabic
    document.dir = 'rtl';
    document.documentElement.lang = 'ar';
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles
        styles={{
          '*': {
            margin: 0,
            padding: 0,
            boxSizing: 'border-box'
          },
          html: {
            height: '100%',
            direction: 'rtl'
          },
          body: {
            height: '100%',
            fontFamily: theme.typography.fontFamily,
            direction: 'rtl'
          },
          '#root': {
            height: '100%'
          }
        }}
      />
      <Auth>
      <LayoutApp />
      </Auth>
    </ThemeProvider>
  );
}

export default App;
